import React from "react";
import { Link, useLocation } from "react-router-dom";

const PathName = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    return (
        <div className="d-flex justify-content-md-end px-3">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb ">
                    <li className="breadcrumb-item">
                        <Link to="/" className=" base-font-600 fs-1 text-black mb-0 text-decoration-none">Dashboard</Link>
                    </li>

                    {pathnames.map((pathname, index) => {
                        const isLast = index === pathnames.length - 1;
                        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}/`;
                        const name = pathname.charAt(0).toUpperCase() + pathname.slice(1);
                        return (
                            <li key={routeTo} className="breadcrumb-item fs-1" >
                                <Link to={routeTo} aria-disabled={isLast && true} aria-readonly={isLast && true} className="fs-1 base-font-600 text-base-color text-decoration-none" style={{ cursor: "default" }}>{name}</Link>
                            </li>
                        )
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default PathName;
